module.exports = __webpack_public_path__ + "img/pexels-photomix-company-106344.55909cf6.jpg";